// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckActivity-module_check-lesson__Ag2md{width:fit-content}@media only screen and (max-width: 1250px){.CheckActivity-module_check-lesson__Ag2md{width:min-content}}`, "",{"version":3,"sources":["webpack://./src/App/views/QuickAnswer/components/CheckActivity.module.scss"],"names":[],"mappings":"AAAA,0CAAc,iBAAiB,CAAC,2CAA2C,0CAAc,iBAAiB,CAAC","sourcesContent":[".check-lesson{width:fit-content}@media only screen and (max-width: 1250px){.check-lesson{width:min-content}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"check-lesson": `CheckActivity-module_check-lesson__Ag2md`
};
export default ___CSS_LOADER_EXPORT___;
